module.exports = __webpack_public_path__ + "img/pin-green.8a0ba86d.svg";